import { performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { toErrorId, toErrorMessage } from '@atlassian/jira-project-settings-apps-common/src/types';
import { famaCatchAndLogFetchError } from '@atlassian/jira-project-settings-apps-common/src/util/catch-and-log-fetch-error';
import { PACKAGE_NAME } from '../../model/constants';
import getProjectDetails from './get-project-details';
import type {
	ProjectContext,
	ProjectDetails,
	ProjectDetailsUpdateSimplified,
	ProjectDetailsUpdate,
} from './types';

/**
 * returns the end point for getting the predefined avatars for the project
 */
export const updateProjectDetailsEndpoint = (context: ProjectContext): string =>
	`${context.baseUrl}/rest/api/2/project/${String(context.projectId)}`;

const updateProjectDetailsSimplified = (
	context: ProjectContext,
	details: ProjectDetailsUpdateSimplified,
): Promise<ProjectDetails> => {
	const updateProjectDetailsPromise = famaCatchAndLogFetchError(
		performPutRequest(updateProjectDetailsEndpoint(context), {
			body: JSON.stringify(details),
		}),
		PACKAGE_NAME,
		toErrorId('updateProjectDetailsSimplified'),
		toErrorMessage('Failed to update project details'),
	);

	// We call off to get the project details again because the response of the update does
	// not contain all of the information we need
	return updateProjectDetailsPromise.then(() => getProjectDetails(context));
};

export const updateProjectDetails = (
	context: ProjectContext,
	details: ProjectDetailsUpdate,
): Promise<ProjectDetails> => {
	const updateProjectDetailsPromise = famaCatchAndLogFetchError(
		performPutRequest(updateProjectDetailsEndpoint(context), {
			body: JSON.stringify(details),
		}),
		PACKAGE_NAME,
		toErrorId('updateProjectDetails'),
		toErrorMessage('Failed to update project details'),
	);

	// We call off to get the project details again because the response of the update does
	// not contain all of the information we need
	return updateProjectDetailsPromise.then(() => getProjectDetails(context));
};

export default updateProjectDetailsSimplified;
